import { render, staticRenderFns } from "./HomepageGirdCategory.vue?vue&type=template&id=52bf5d16"
import script from "./HomepageGirdCategory.vue?vue&type=script&lang=js"
export * from "./HomepageGirdCategory.vue?vue&type=script&lang=js"
import style0 from "./HomepageGirdCategory.vue?vue&type=style&index=0&id=52bf5d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports